//@ts-nocheck
import { DepartmentResponse } from '../store/slices/message/messageType';
import { formatUrl } from '../utils/urlFormatter';
import { get, del, post, put } from '../store/apiClient';




const create_team_message = '/candidateMessage.add';
const fetch_team_messages_list = '/{0}/candidateMessage.list';
const update_team_message = '/{0}/candidateMessage.update';
const delete_team_message = '/{0}/candidateMessage.delete';


const credentialsConfig = {
    withCredentials: true,
}


export const createTeamMessage = async (payload: {
    formData: FormData;
}): Promise<DepartmentResponse> => {
    // Use the direct URL instead of trying to format it
    const endpoint = create_team_message; // This is already '/candidateMessage.add'

    return post<DepartmentResponse>(
        endpoint,
        payload.formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            ...credentialsConfig,
        }
    );
};

export const fetchTeamMessagesList = async (payload: {
    appID: number;
    page?: number;
    limit?: number;
    type?: string;
    privacy?: string;
    user_type?: string;
    status?: string;
}): Promise<DepartmentResponse> => {
    const { appID, page = 1, limit = 25, type, privacy, user_type, status } = payload;


    const endpoint = formatUrl(fetch_team_messages_list, [appID]);
    const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(type ? { type } : {}),
        ...(privacy ? { privacy } : {}),
        ...(user_type ? { user_type } : {}),
        ...(status ? { status } : {}),
    }).toString();


    return get<DepartmentResponse>(`${endpoint}?${queryParams}`, credentialsConfig);
};


// update team message
export const updateTeamMessage = async (
    id: number,
    messageContent: string
): Promise<DepartmentResponse> => {
    const update_teams_data = formatUrl(update_team_message, [id]); // Ensure correct URL format
    const payload = { message: messageContent }; // Correct payload format
    return put<DepartmentResponse>(update_teams_data, payload, credentialsConfig);
};

export const deleteTeamMemberMessage = async (id: number): Promise<DepartmentResponse> => {
    const formattedUrl = formatUrl(delete_team_message, [id]);
    return del<DepartmentResponse>(formattedUrl, credentialsConfig);
};
